import { memo } from "react";
import useAuth from "../../hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { getDefaultAuthorizedRoute } from "../../utils/common";

export function AdminGuard({ children }) {
  const { isAuthenticated, accessType, user } = useAuth();
  const location = useLocation();

  if (location.pathname != "/admin/bot-settings") {
    localStorage.removeItem("chatSource");
    localStorage.removeItem("botStyle");
    localStorage.removeItem("botWorkFlowEdge");
    localStorage.removeItem("botWorkFlowNode");
    localStorage.removeItem("chatElement");
    localStorage.removeItem("chatNode");
  }

  if (!isAuthenticated && user === null) {
    return <Navigate to="/" />;
  }

  if (user && (accessType === 2 || accessType === 4)) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  if (user && accessType === 3) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  if (user && accessType === 5) {
    return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
  }

  return <>{children}</>;
}

AdminGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(AdminGuard);
